module.exports = __webpack_public_path__ + "static/img/167_phase_function_Paper_PointsHejduk_Prediction.d044faf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/167_phase_function_Paper_PointsHejduk_Prediction.png
// module id = ncis
// module chunks = 0